import axios from 'axios';
import { AppNavigation } from '../routes/layout/components/navigation/interfaces/navigation.interface';

const API_URL = process.env.REACT_APP_API_URL;

export const getNavigationService = async (): Promise<AppNavigation[]> => {
  return (await axios.get(`${API_URL}navigation`, {})).data;
};
